import HttpCliente from '../HttpCliente';

export const getClientes = (token) => {
  return new Promise((resolve, reject) => {
    HttpCliente.get('/Cliente/ObtenerClientes', {
      headers: {
        'Authorization': `Bearer ${token}`,
        'accept': 'text/plain'
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      reject(error);
    });
  });
};

export const postClientes = (token, cliente) => {
  return new Promise((resolve, reject) => {
    HttpCliente.post('/Cliente/Crear', cliente, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'accept': 'text/plain',
        'Content-Type': 'application/json',
        }
    }).then(response => {
        resolve(response.data);
        }).catch(error => {
        reject(error);
        });
    });
}

export const putClientes = (token, cliente) => {
    return new Promise((resolve, reject) => {
        HttpCliente.put(`/Cliente/EditarCliente`, cliente, {
        headers: {
            'Authorization': `Bearer ${token}`,
            'accept': 'text/plain',
            'Content-Type': 'application/json',
            }
        }).then(response => {
            resolve(response.data);
            }).catch(error => {
            reject(error);
            });
    });
}

export const deleteClientes = (token, id) => {
    return new Promise((resolve, reject) => {
        HttpCliente.delete(`/Cliente/Eliminar/${id}`, {
        headers: {
            'Authorization': `Bearer ${token}`,
            'accept': 'text/plain',
            }
        }).then(response => {
            resolve(response.data);
            }).catch(error => {
            reject(error);
            });
        });
    }

export const getClienteHabilitado = (token) => {
    return new Promise((resolve, reject) => {
      HttpCliente.get('/Cliente/ObtenerClienteHabilitado', {
        headers: {
          'Authorization': `Bearer ${token}`,
          'accept': 'text/plain'
        }
      }).then(response => {
        resolve(response.data);
      }).catch(error => {
        reject(error);
      });
    });
  };

export const postRelacionClienteOrganismo = (token, relacion) => {
  return new Promise((resolve, reject) => {
    HttpCliente.post('/Cliente/RelacionarClienteConOrganismosEmisores', relacion, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'accept': 'text/plain',
        'Content-Type': 'application/json',
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      reject(error);
    });
  });
};

export const postRelacionClienteRubro = (token, relacion) => {
  return new Promise((resolve, reject) => {
    HttpCliente.post('/Cliente/RelacionarClienteConRubros', relacion, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'accept': 'text/plain',
        'Content-Type': 'application/json',
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      reject(error);
    });
  });
};

export const postRelacionClienteOrganismoTipoDocumento = (token, relacion) => {
  return new Promise((resolve, reject) => {
    HttpCliente.post('/Cliente/RelacionarOrganismoTipoDocumento', relacion, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'accept': 'text/plain',
        'Content-Type': 'application/json',
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      reject(error);
    });
  });
};

export const getModulosPorClienteId = (token, idCliente) => {
  return new Promise((resolve, reject) => {
    HttpCliente.get(`/Modulo/ObtenerModulosPorClienteId/${idCliente}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'accept': 'text/plain'
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      reject(error);
    });
  });
};

// Actualizar las funciones de semáforo para incluir módulo
export const postConfiguracionSemaforo = (token, semaforo) => {
  return new Promise((resolve, reject) => {
    HttpCliente.post('/Cliente/ConfigurarSemaforo', semaforo, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'accept': 'text/plain',
        'Content-Type': 'application/json',
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      reject(error);
    });
  });
};

export const getConfiguracionSemaforo = (token, idCliente) => {
  return new Promise((resolve, reject) => {
    HttpCliente.get(`/Cliente/ObtenerConfiguracionSemaforo/${idCliente}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'accept': 'text/plain'
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      if (error.response && error.response.status === 404) {
        resolve(null); // No tiene configuración
      } else {
        reject(error);
      }
    });
  });
};

export const getConfiguracionesSemaforoPorCliente = (token, idCliente) => {
  return new Promise((resolve, reject) => {
    HttpCliente.get(`/Cliente/ObtenerConfiguracionesSemaforoPorCliente/${idCliente}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'accept': 'text/plain'
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      reject(error);
    });
  });
};

export const getTodasConfiguracionesSemaforo = (token) => {
  return new Promise((resolve, reject) => {
    HttpCliente.get('/Cliente/ObtenerTodasConfiguracionesSemaforo', {
      headers: {
        'Authorization': `Bearer ${token}`,
        'accept': 'text/plain'
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      reject(error);
    });
  });
};

export const validarModulosCompromisosObligaciones = (token, idCliente) => {
  return new Promise((resolve, reject) => {
    HttpCliente.get(`/Cliente/ValidarModulosCompromisosObligaciones/${idCliente}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'accept': 'text/plain'
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      reject(error);
    });
  });
};

export const tieneModulosCompromisosObligaciones = (token, idCliente) => {
  return new Promise((resolve, reject) => {
    HttpCliente.get(`/Cliente/TieneModulosCompromisosObligaciones/${idCliente}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'accept': 'text/plain'
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      reject(error);
    });
  });
};

export const validarClienteTieneModuloSemaforo = (token, idCliente) => {
  return new Promise((resolve, reject) => {
    HttpCliente.get(`/Cliente/ValidarModuloSemaforo/${idCliente}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'accept': 'text/plain'
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      reject(error);
    });
  });
};

export const getClientesAutomaticos = (token, organismoEmisorId, tipoDocumentoId, rubroIds) => {
  return new Promise((resolve, reject) => {
    const requestBody = {
      organismoEmisorId: organismoEmisorId,
      tipoDocumentoId: tipoDocumentoId,
      rubroIds: rubroIds || []
    };

    HttpCliente.post("/Cliente/GetClientesAutomaticos", requestBody, {
      headers: {
        "Authorization": `Bearer ${token}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      console.error("Error al obtener clientes automáticos:", error);
      reject(error);
    });
  });
};